import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import CheckList from '../molecules/CheckList';
import { BrowserFrame, KanbanMockup } from '../molecules/Mockups';
import { IconClock } from '../atoms/Icon';
import Reveal from '../atoms/Reveal';
import { contato, painel } from '../content/site';

/** O lado do lojista. A ordem das colunas se inverte em relação à seção do
 *  cardápio — texto à direita, tela à esquerda — para a página não virar uma
 *  fileira de blocos idênticos. */
function PanelSection() {
  return (
    <section className="section" id="painel">
      <Container className="shell">
        <Row className="align-items-start g-4 gy-5">
          <Col lg={6} className="order-lg-2">
            <span className="section-kicker">{painel.kicker}</span>
            <h2 className="section-title">{painel.titulo}</h2>
            <p className="section-lead mb-4">{painel.texto}</p>

            <CheckList items={painel.itens} />

            {/* O Dashboard está no menu do admin marcado como "Em breve" e
                desabilitado. Ele aparece aqui pelo mesmo motivo que aparece lá:
                é melhor a pessoa saber que está vindo do que descobrir que não
                existe depois de assinar. */}
            <p
              className="d-inline-flex align-items-center gap-2 mt-4 mb-0 px-3 py-2"
              style={{
                borderRadius: 'var(--radius-pill)',
                backgroundColor: 'var(--color-warning-soft)',
                color: 'var(--color-warning)',
                fontSize: 'var(--text-sm)',
                fontWeight: 'var(--weight-medium)',
              }}
            >
              <IconClock size={16} />
              {painel.rodape}
            </p>
          </Col>

          <Col lg={6} className="order-lg-1">
            <Reveal heavy>
              <BrowserFrame url={`${contato.appUrl.replace('https://', '')}/pedidos`}>
                <KanbanMockup />
              </BrowserFrame>
            </Reveal>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default PanelSection;
